<template>
  <div class="container-fluid contact">
    <div class="row contact-heading mb-4">
      <div class="col-12 text-center">
        <h3 class="font-weight-bold">Contact Us</h3>
        <span>We are available 24 x 7</span>
        <br />
        <span>
          Response Time :
          <span class="f-theme-color">2 - 3 hours</span>
        </span>
      </div>
    </div>
    <div class="row justify-content-center align-items-center h-100 pt-4">
      <div class="col-sm-12">
        <form class="contact-form">
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <input
                type="text"
                class="form-control form-control-sm f-form-control"
                placeholder="Name"
                v-model="name"
                required
              />
              <span class="text-danger" v-if="errors[0]">{{ errors[0] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mt-3 mb-3">
              <input
                type="text"
                class="form-control form-control-sm f-form-control"
                placeholder="E-Mail"
                v-model="email"
                required
              />
              <span class="text-danger" v-if="errors[1]">{{ errors[1] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mt-3 mb-3">
              <input
                type="text"
                class="form-control form-control-sm f-form-control"
                placeholder="Subject"
                v-model="subject"
                required
              />
              <br />
              <span v-if="subject && subject.length <= 200"
                >{{ subject.length }}/200</span
              >
              <span
                v-else-if="subject && subject.length > 200"
                class="text-danger"
                >{{ 200 - subject.length }}/200</span
              >
              <span class="text-danger" v-if="errors[3]">{{ errors[3] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mt-3 mb-3">
              <textarea
                class="form-control form-control-sm f-form-control"
                rows="12"
                v-model="query"
                placeholder="Describe your query"
              ></textarea>
              <span class="text-danger" v-if="errors[2]">{{ errors[2] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-12 mt-3 mb-4 text-center">
              <span
                class="text-danger pt-2"
                v-if="errors[0] || errors[1] || errors[2]"
                >Looks like you missed something. Please Check</span
              >
              <br v-if="errors[0] || errors[1] || errors[2]" />
              <br />
              <button
                type="submit"
                class="btn btn-submit btn-fasdo-primary"
                @click.prevent="save()"
              >
                SUBMIT
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <LoaderGif :disable="loading" :success="success" :message="message" />
  </div>
</template>

<script>
import axios from "axios";
import Vue from "Vue";
import {
  domain,
  ContentType,
  AccessControlAllowOrigin,
  XRequestedWith
} from "@/store/variable";
import LoaderGif from "./LoaderGif.vue";

export default {
  name: "ContactUs",
  components: {
    LoaderGif
  },
  data() {
    return {
      name: null,
      email: null,
      subject: null,
      query: null,
      errors: [null, null, null],
      loading: false,
      success: false,
      message: null
    };
  },
  methods: {
    save() {
      if (this.validate()) {
        let url = domain + "contact/query";
        this.loading = true;
        axios
          .post(
            url,
            {
              name: this.name,
              email: this.email,
              subject: this.subject,
              query: this.query
            },
            {
              withCredentials: true,
              headers: {
                "Content-Type": ContentType,
                "X-Requested-With": XRequestedWith
              }
            }
          )
          .then(res => {
            if (res.data == "Success") {
              //// to show

              this.message =
                "Thankyou for taking out your time.Your Query has been submitted. We'll be back soon!";
              this.success = true;
              this.loading = false;

              setTimeout(() => {
                this.success = false;
                this.message = null;
              }, 5000);
            }
          })
          .catch(err => {
            this.message =
              "Sorry! Looks like some error has occured. Please Try again later";
            this.success = true;
            this.loading = false;

            setTimeout(() => {
              this.success = false;
              this.message = null;
            }, 5000);
          });
      }
    },

    validate() {
      this.errors = [null, null, null];
      if (
        this.name &&
        this.email &&
        this.subject &&
        this.subject.length <= 200 &&
        this.query &&
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) &&
        /^[a-zA-Z^\s]+$/.test(this.name)
      ) {
        return true;
      } else {
        if (!this.name) {
          Vue.set(this.errors, 0, "Please enter name");
        } else if (/^[a-zA-Z^\s]+$/.test(this.name) == false) {
          Vue.set(this.errors, 0, "Please enter valid name");
        }

        if (!this.email) {
          Vue.set(this.errors, 1, "Please enter email");
        } else if (
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) ==
          false
        ) {
          Vue.set(this.errors, 1, "Please enter valid email");
        }

        if (!this.subject) {
          Vue.set(this.errors, 3, "Please enter subject");
        } else if (this.subject.lenght > 200) {
          Vue.set(this.errors, 3, "Please write subject in 200 words");
        }

        if (!this.query) {
          Vue.set(this.errors, 2, "Please write down some query");
        }
        return false;
      }
    }
  }
};
</script>

<style scoped>
.contact {
  margin-top: 10em;
}

.contact-heading span {
  font-size: larger;
}

.contact-form {
  margin: 0 auto;
  width: 65%;
}

.contact-form .btn-submit {
  padding: 0.765rem 3.265rem;
  font-size: x-large;
}

.contact-fixed {
  position: fixed;
  top: 13em;
  left: 15em;
  right: 15em;
  padding: 2em;
  z-index: 100;
}

@media only screen and (max-width: 768px) {
  .contact {
    margin-top: 7em;
  }

  .contact-form {
    margin: 0 auto;
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue